module.exports = __webpack_public_path__ + "img/24.481bc8fa.png";